export default __webpack_public_path__ + "static/Mont-Heavy-1b3ba2d71fc1b2b28d58cd7a02ae9229.otf";